// extracted by mini-css-extract-plugin
export default {"customToastClass":"toastConfig_customToastClass__7+wSU"};